import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import RecordRTC from "recordrtc";
import SafaryWorker from "../Shared/SafariWorker";
import {BUCKET_URL} from "../Shared/Consts";
import lamejs from "lamejs";

import "../assets/students/WordSignSay.css";
import LoadingModal from "../LoadingModalComponent/LoadingModal";
import {Buttons, Buttons1, VideoComponent} from "./Common";
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import videoInstructionPN from '../assets/images/video_instructions.png';
import videoMaskPN from '../assets/images/video_mask.png';
import DialogBox from "../Shared/DialogBox";
import {isIOS, isSafari} from "react-device-detect";
import InstructionModals from "../Shared/InstructionModals";
import {clearInterval, setInterval} from "timers";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import connect from "react-redux/es/connect/connect";
import TRACKING from "../Shared/DataTrackingPoints";

let hasGetUserMedia = false;
try {
    hasGetUserMedia = !!navigator.getUserMedia ||!!navigator.mediaDevices.getUserMedia || !!navigator.webkitGetUserMedia || !!navigator.mozGetUserMedia || !!navigator.msGetUserMedia;
}
catch(err) {
    hasGetUserMedia = !!navigator.getUserMedia || !!navigator.webkitGetUserMedia || !!navigator.mozGetUserMedia || !!navigator.msGetUserMedia ;
}

let newSes = `{
	"AV_FileName": "",
	"wssDolceWords": [{
		"id": 35,
		"createdAt": "2018-10-17T17:34:33.423Z",
		"updatedAt": "2018-10-17T17:34:33.423Z",
		"word": "many",
		"deletedAt": null
	}, {
		"id": 8,
		"createdAt": "2018-10-17T17:34:33.423Z",
		"updatedAt": "2018-10-17T17:34:33.423Z",
		"word": "buy",
		"deletedAt": null
	}, {
		"id": 70,
		"createdAt": "2018-10-17T17:34:33.423Z",
		"updatedAt": "2018-10-17T17:34:33.423Z",
		"word": "want",
		"deletedAt": null
	}],
	"startLevel": 1,
	"startProgress": 1,
	"assessmentType": 0,
	"guid": "644f9ece-da89-4f93-bd6a-8292520b7973"
}`;

let bestScor = `{
	"success": true,
	"body": {
		"id": 4430,
		"userId": 6974,
		"createdAt": "2018-10-16T18:36:55.759Z",
		"updatedAt": "2018-12-24T09:27:26.541Z",
		"mazeLevel": 3,
		"mazeScore": 2,
		"slashLevel": 4,
		"slashScore": 2,
		"ksLevel": 4,
		"ksScore": 1,
		"pnLevel": 2,
		"pnScore": 1,
		"crLevel": 2,
		"crScore": 1,
		"wssLevel": 1,
		"wssScore": 1,
		"kssLevel": 3,
		"kssScore": 2,
		"deletedAt": null
	},
	"msg": ""
}`;

let testWSS = `[{
	"id": 35,
	"createdAt": "2018-10-17T17:34:33.423Z",
	"updatedAt": "2018-10-17T17:34:33.423Z",
	"word": "many",
	"deletedAt": null
}, {
	"id": 8,
	"createdAt": "2018-10-17T17:34:33.423Z",
	"updatedAt": "2018-10-17T17:34:33.423Z",
	"word": "buy",
	"deletedAt": null
}, {
	"id": 70,
	"createdAt": "2018-10-17T17:34:33.423Z",
	"updatedAt": "2018-10-17T17:34:33.423Z",
	"word": "want",
	"deletedAt": null
}]`;

let recordedSession = true;
let params = null;


class WordSignSayComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            modalActive:true,
            loadedScores: false,
            bestScores:{
                wssScore:1,
                wssLevel:1
            }
        };
    }

    async componentDidMount() {
        await Helpers.authorize(this);
        await REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores:response.body
                });
            }
        });
        await REST.getStudentAppStatus().then(async(res)=>{
            await this.props.updateStudentAppStatus(res.body);
            let {allowedApps, filteredApps, finishedApps} = Helpers.filterApps(this.props.studentUser,this.props.apps);
            await this.props.updateAppStates({
                allowedApps:allowedApps,
                filteredApps:filteredApps,
                finishedApps:finishedApps
            });
            await this.setState({bestScores: res.body.bestScores})
        });
        if(this.props.apps.wordSignSayScores.filter(function(x){return x.gradingDate==null}).length > 3){
            this.props.history.goBack();
        }
    }

    handleSurveyBack = (modalActive) => {
    };

    handleModalBack = (modalActive) => {
        this.setState({modalActive: modalActive});
    };

    handleActive = (active) => {
        this.setState({active: active});
    };

    handleBeginTest = () => {
        this.setState({active: 3});
    };

    render() {
        return (
            <div className={this.state.active !==2 ? "bgGrey WordSignSay" : "bgYellow WordSignSay"}>
                {
                    this.state.active === 0 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <DialogBox surveyModal userId={this.props.studentUser.id} app={'Word Sign/Say'} active={true} surveyBack={this.handleSurveyBack}/>
                                <div className={"container"}>
                                    <div className="appContainer progressBox1">
                                        <h1 style={{textAlign: "center",fontSize:'42px'}}>Word Sign/Say</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        appName={"wordsignsay"}
                                                        speed={true}
                                                        level={this.state.bestScores.wssLevel}
                                                        step={this.state.bestScores.wssScore}
                                                        steps={3}
                                                        maxLevel={1}
                                                        noDescription
                                                    /> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"wordsignsay"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1 ?
                        <div>
                            <div className={"appSection bgGrey"}>
                                <div className={"container"} >
                                    <Buttons1 demo appName={"wordsignsay"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>

                                    <div className="appContainer wordsignsay">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>Word Sign/Say: Show Me</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <VideoComponent url={"https://s3.us-east-2.amazonaws.com/uploaddev/video/picturenaming/WSS.mp4"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons demo appName={"wordsignsay"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 practice appName={"wordsignsay"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <Tutorial studentUser={this.props.studentUser} buttonClick = {this.handleActive}  beginTest={this.handleBeginTest}/>
                            <Buttons appName={"wordsignsay"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"wordsignsay"} recordedSession={this.state.modalActive} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <WordSignSay studentUser={this.props.studentUser} buttonClick = {this.handleActive} backBtn={this.handleModalBack} />
                            <Buttons appName={"wordsignsay"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
            </div>
        )
    }
}

class WordSignSay extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showVideo: true,
            isUploading:false,
            timeInterval: 3,
            isCounting:false,
            countdown:-1,
            countDownTimer:null,
            rotateTimer:null,
            bestScores: null,
            recordVideo: null,
            rejectedReason: '',
            recording: false,
            dolceWord: "",
            wordIndex:-1,
            videoSrc: false,
            audioSrc:false,
            audioBlob:false,
            recordAudio:null,
            audioVideoSwitch:"video",
            modalDialog: false,
            modalInstruction: false,
            responseContent:'',
            recordedSession:false,
            upTime:null,
            sessionData: {
                AV_FileName: "",
                wssDolceWords: [],
                startLevel: 1,
                startProgress: 1,
                assessmentType: 0,
                guid: require('uuid/v4')()
            }
        };

        this.handleStartWordSignSay = this.handleStartWordSignSay.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleShowVideo = this.handleShowVideo.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.setStreamToVideo = this.setStreamToVideo.bind(this);
        this.releaseStreamFromVideo = this.releaseStreamFromVideo.bind(this);
        this.uploadVideo = this.uploadVideo.bind(this);
        this.requestUserMedia = this.requestUserMedia.bind(this);
        this.startRecord = this.startRecord.bind(this);
        this.stopRecord = this.stopRecord.bind(this);
        this.handleBackToMenu = this.handleBackToMenu.bind(this);
        this.toggleAudioVideo = this.toggleAudioVideo.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.handleToggleInstruction = this.handleToggleInstruction.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    onUnload(event) { // the method that will be used for both add and remove event
        event.returnValue = "By leaving or reloading the page you will lose your app progress"
    }

    async componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload);
        if(/firefox/i.test(navigator.userAgent)){
            this.setState({
                modalDialog: true,
                responseContent: 'Please use Safari or Chrome browser for this task'
            });
            return;
        }
        Helpers.authorize(this);
        if (!hasGetUserMedia) {
            this.setState({
                modalDialog: true,
                responseContent:!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && (navigator.userAgent.match('CriOS') || navigator.userAgent.match('Mozilla')) ? 'Please use Safari (above version 11) for this task.' : 'Your browser cannot stream from your webcam. Please switch to Chrome.'

            });
            return;
        }
        this.requestUserMedia();
        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_WSS_START,
                metadata: {
                    platform: navigator.platform,
                    userAgent: navigator.userAgent
                }
            }
        })
        this.handleAnalytics();
    };

    componentWillUnmount(){
        window.removeEventListener("beforeunload", this.onUnload);
        if(this.state.recording){
            if(this.state.audioVideoSwitch==="video") {
                this.state.recordVideo.stop(res => {
                });
            }else{
                this.state.recordAudio.stop(res => {
                });
            }
            clearInterval(this.state.countDownTimer);
            clearInterval(this.state.rotateTimer);
            this.captureUserMedia((stream) => {
                stream.stop();
            });
        }
        if(this.video && this.video.srcObject){
            this.video.srcObject.stop();
        }
    }
    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleShowVideo(){
        this.setState({showVideo:!this.state.showVideo});
    }

    handleCloseModal(active){
        window.removeEventListener("beforeunload", this.onUnload);
        this.setState({modalDialog:active});
        window.location.reload();
        // this.props.buttonClick(0);
    }

    handleToggleInstruction= (toggleInstruction) => {
        localStorage.setItem('WSSInstruction', toggleInstruction);
    }

    handleBackToMenu(e) {
        this.props.history.goBack();
    }

    requestUserMedia() {
        this.captureUserMedia((stream) => {
            this.setStreamToVideo(stream);
        });
    }

    handleStart(stream) {
        this.setState({
            recording: true
        });

        this.setStreamToVideo(stream);
    }

    handleStop(blob) {
        this.setState({
            recording: false
        });

        if(this.state.audioVideoSwitch==="video") {
            this.releaseStreamFromVideo();
        }else {
            this.releaseStreamFromAudio();
        }

        this.uploadVideo(blob instanceof Blob, blob);
    }

    setStreamToVideo(stream) {
        this.video.srcObject = stream;
    }

    releaseStreamFromVideo() {
        this.video.srcObject = null;
    }

    async encodeMono(channels, sampleRate, samples) {
        let kbps = 256; //encode 128kbps mp3
        let mp3encoder = new lamejs.Mp3Encoder(channels, sampleRate, kbps);
        let sampleBlockSize = 1152; //can be anything but make it a multiple of 576 to make encoders life easier

        let mp3Data = [];
        for (let i = 0; i < samples.length; i += sampleBlockSize) {
            let sampleChunk = samples.subarray(i, i + sampleBlockSize);
            let mp3buf = mp3encoder.encodeBuffer(sampleChunk);
            if (mp3buf.length > 0) {
                mp3Data.push(mp3buf);
            }
        }
        let mp3buf = mp3encoder.flush();   //finish writing mp3

        if (mp3buf.length > 0) {
            mp3Data.push(new Int8Array(mp3buf));
        }
        let blob = new Blob(mp3Data, {type: 'audio/mp3'});
        await this.setState({
            audioBlob:blob
        });
        this.handleStop(blob);
    }

    setStreamToAudio(stream) {
        this.audio.srcObject = stream;
    }

    releaseStreamFromAudio() {
        this.audio.pause();
        this.audio.srcObject = null;
        this.audio.src = "";
        this.audio.load();
    }

    startRecordAudio() {
        this.captureUserMedia((stream) => {
            let options = {
                type: 'audio',
                audio:this.audio,
                sampleRate: 44100,
                bufferSize: 4096,
                numberOfAudioChannels:1,
                recorderType: RecordRTC.StereoAudioRecorder
            };

            this.setState({recordAudio:new RecordRTC.StereoAudioRecorder(stream,options)});
            this.state.recordAudio.record();
            this.handleStartAudio(stream);
        },{audio:true,video:false});
    }

    handleStopAudio(wavBlob) {
        this.setState({
            recording: false
        });

        let fileReader = new FileReader();
        fileReader.onload = (event) => {
            let arrayBuffer = event.target.result;
            let wav = lamejs.WavHeader.readHeader(new DataView(arrayBuffer));
            let samples = new Int16Array(arrayBuffer, wav.dataOffset, wav.dataLen / 2);
            this.encodeMono(wav.channels, wav.sampleRate, samples);
            this.releaseStreamFromAudio();
        };
        fileReader.readAsArrayBuffer(wavBlob);
    }

    handleStartAudio(stream) {
        this.setState({
            recording: true
        });

        this.setStreamToAudio(stream);
    }

    stopRecordAudio() {
        this.state.recordAudio.stop((wavBlob) => {
            this.handleStopAudio(wavBlob);
        });
    }

    async getMediaParam(options){
        let userAgent = await navigator.userAgent;
        if(options){
            params = options;
        }else if(/Chrome/i.test(userAgent)&&/Windows/i.test(userAgent)){
            params = {
                audio:true,
                video:true
            };
        }else{
            params = {
                audio:true,
                video: await Helpers.getVideoSizes()
            };
        }
        return params;
    }

    captureUserMedia = async (callback, options) => {

        let params = null;
        params = await this.getMediaParam(options);
        navigator.mediaDevices.getUserMedia(params)
            .then(callback)
            .catch(error => {
                this.setState({
                    modalDialog: true,
                    responseContent: error
                });
            });
    };

    uploadVideo(isBlob, blob) {
        console.log('start to upload');
        REST.uploadWSSVideo(isBlob, blob).then(res => {
            if(this.state.audioVideoSwitch==="video") {
                this.video.src = BUCKET_URL + res.body.filepath;
                this.setState({videoSrc: this.video.src});
            }else{
                this.audio2.src = BUCKET_URL + res.body.filepath;
                this.audio2.load();
                this.audio2.play();
            }
            let seshData = this.state.sessionData;
            seshData.AV_FileName = res.body.filepath;
            this.setState({isUploading:false,recordedSession: true});
            if(!this.props.practice) {
                window.removeEventListener("beforeunload", this.onUnload);
                REST.insertWSSSession(seshData).then(res => {
                    this.setState({
                        modalDialog: true,
                        responseContent:'Video saved'
                    });
                });
            }
            else{
                this.setState({
                    modalDialog: true,
                    responseContent:'Practice Finished'
                });
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                modalDialog: true,
                responseContent:'Failed to save video.'
            });
        });
    }

    rotateWords = (words) => {
        let i = 0;
        let time = this.state.timeInterval;
        this.setState({countdown:time});
        let countDownTimer = setInterval(async () => {
            await this.setState({
                countdown:this.state.countdown-1
            });
            if(this.state.countdown<0){
                clearInterval(countDownTimer);
            }
            if(this.state.countdown === 0){
                await this.setState({isCounting:false});
                this.startRecord();
            }
        }, 1000);

        let timer = setInterval(() => {
            if (i === words.length) {
                this.setState({
                    dolceWord: "",
                    wordIndex:-1
                });
                this.stopRecord();
                clearInterval(timer);
            } else {
                let word = words[i];
                this.setState({
                    dolceWord: word.word,
                    wordIndex:i
                });
                i++;
            }
        }, 1000 * time);

        this.setState({
            countDownTimer:countDownTimer,
            rotateTimer:timer
        })
    };

    handleStartWordSignSay = async () => {
        await this.setState({isCounting:true});
        if(!this.props.practice) {
            this.props.backBtn(false);
            REST.getWSSRandom().then(async (res) => {
                let wssDolceWords = res.body;
                let bestScores = await REST.getBestScores();
                let newSesh = this.state.sessionData;
                newSesh.startLevel = bestScores.body.wssLevel;
                newSesh.startProgress = bestScores.body.wssScore;
                newSesh.wssDolceWords = wssDolceWords;
                await this.setState({
                    bestScores: bestScores.body,
                    timeInterval: 3,
                    sessionData: newSesh
                });
                this.rotateWords(wssDolceWords);

            }).catch(error => {
            });
        }
        else{
            if(typeof newSes !== 'object' && newSes !== null){
                newSes = await JSON.parse(newSes);
            }
            if(typeof bestScor !== 'object' && bestScor !== null){
                bestScor = await JSON.parse(bestScor);
            }
            if(typeof testWSS !== 'object' && testWSS !== null){
                testWSS = await JSON.parse(testWSS);
            }
            await this.setState({
                bestScores: bestScor.body,
                timeInterval: 3,
                sessionData: newSes
            });
            this.rotateWords(testWSS);
        }
    };

    noWebM(){
        return isIOS || isSafari;
    }

    startRecordVideo() {

        this.captureUserMedia((stream) => {
            let audio_options = {
                type: 'audio',
                audio:this.audio,
                sampleRate: 44100,
                bufferSize: 4096,
                numberOfAudioChannels:1,
                recorderType: RecordRTC.StereoAudioRecorder
            };

            let video_options;
            let videoRecorderClass;
            if(this.noWebM()){

                video_options = {
                    type: 'video',
                    recorderType: RecordRTC.WhammyRecorder,
                    frameInterval: 50,
                    video: this.video,
                    width: 320,
                    height: 240
                };

                videoRecorderClass = new SafaryWorker().WhammyRecorder(stream, video_options);
            }else{

                video_options = {
                    mimeType: 'video/webm',
                    recorderType: RecordRTC.MediaStreamRecorder,
                    width: 320,
                    height: 240
                };

                videoRecorderClass = new RecordRTC.MediaStreamRecorder(stream,video_options);
            }

            this.setState({
                recordAudio:new RecordRTC.StereoAudioRecorder(stream,audio_options),
                recordVideo: videoRecorderClass
            },()=>{
                if(this.noWebM()) {
                    this.state.recordVideo.record(this.state.recordAudio.record());
                }else {
                    this.state.recordVideo.record();
                }
                this.handleStart(stream);
            });
        },{
            audio:true,
            video: Helpers.getVideoSizes()
        });
    }

   async handleStopWrapper(vidResult,wavBlob){
        this.setState({
            recording: false
        });
       const vidETA = await Helpers.calculateETA(vidResult,wavBlob);
       this.setState({
           upTime: vidETA
       });
       await this.startTimer();
        if(!this.props.practice) {
            if (this.state.audioVideoSwitch === "video") {
                this.releaseStreamFromVideo();
                if (this.noWebM()) {
                    this.releaseStreamFromAudio();
                }
            }
            await REST.uploadWSSVideo(true, vidResult, wavBlob).then(res => {
                if (this.state.audioVideoSwitch === "video") {
                    this.video.src = BUCKET_URL + res.body.filepath;
                    this.setState({videoSrc: this.video.src});
                }
                let seshData = this.state.sessionData;
                seshData.AV_FileName = res.body.filepath;
                this.setState({isUploading: false, recordedSession: true});
                if (!this.props.practice) {
                    REST.insertWSSSession(seshData).then(res => {
                        this.setState({
                            modalDialog: true,
                            responseContent: 'Video saved'
                        });
                    });
                }
                window.removeEventListener("beforeunload", this.onUnload);
                return false;
            }).catch(error => {
            });
        }
        else{
            this.setState({
                modalDialog: true,
                responseContent: 'Practice Finished'
            });
        }

    }

    stopRecordVideo() {

        if(this.noWebM()) {
            const promise1 = () => {
                return new Promise((resolve, reject) => {
                    this.state.recordAudio.stop((wavBlob) => {
                        resolve(wavBlob);
                    });
                });
            };

            const promise2 = () => {
                return new Promise((resolve, reject) => {
                    this.state.recordVideo.stop((result) => {
                        resolve(result);
                    });
                });
            };

            Promise.all([promise1(),promise2()]).then((values)=>{
                if(values[0] instanceof Array){
                    this.handleStopWrapper(values[0],values[1]);
                }else{
                    this.handleStopWrapper(values[1],values[0]);
                }
            });
        }else{
            this.state.recordVideo.stop((result) => {
                this.handleStopWrapper([],result);
            });
        }

    }

    stopRecord() {
        if(this.state.audioVideoSwitch==="video"){
            this.stopRecordVideo();
        }else{
            this.stopRecordAudio();
        }
        this.setState({
            recording:false,
            isUploading:true,
            recordedSession: true
        });
        if(!this.props.practice) {
            this.props.backBtn(this.state.recordedSession);
        }
    }

    startRecord() {
        if(this.state.audioVideoSwitch==="video"){
            this.startRecordVideo();
        }else{
            this.startRecordAudio();
        }
        this.setState({
            recording:true
        });
    }

    toggleAudioVideo(){
        if(this.state.audioVideoSwitch==="video"){
            this.setState({
                audioVideoSwitch:"audio"
            });
            this.releaseStreamFromVideo();
        }else{
            this.setState({
                audioVideoSwitch:"video"
            });
            this.releaseStreamFromAudio();
            this.requestUserMedia();
        }
    }

    startTimer() {
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        let seconds = this.state.upTime - 1;
        this.setState({upTime: seconds});
        if (seconds <= 0) {
            clearInterval(this.timer);
        }
    }

    render() {

        let imageNumerical = this.state.sessionData.wssDolceWords.map((wssWord,index)=>{
            return(
                <li className={index<=this.state.wordIndex ? "item_done":""}>{(index+1).toString()}</li>
            )
        });

        let countDown = (
            <div hidden={this.state.wordIndex>-1}>
                <h1 className={"fontCountdown"} hidden={this.state.countdown<=0}>{this.state.countdown}</h1>
                <img hidden={this.state.wordIndex>-1 || this.state.countdown!==-1 || this.state.recordedSession} src={videoInstructionPN} style={{marginTop:'15%'}}/>
                {/*<h1 style={{fontSize:"20pt", marginTop:"40%"}} hidden={this.state.wordIndex>-1 || this.state.countdown!==-1}>*/}
                    {/*After you click <br/>Start Game Recording,<br/> there is a countdown that indicates how many seconds a new word will be shown and the test starts.*/}
                {/*</h1>*/}
            </div>
        );

        let wordsSlideshow = this.state.sessionData.wssDolceWords.map((wssWord,index)=>{
            return(
                <div className={"WssFontSize"} style={{marginTop:"20%",textTransform:'lowercase'}} hidden={this.state.wordIndex !== index}><h1 style={{textTransform:'lowercase'}}>{wssWord.word}</h1></div>
            )
        });

        return (
            <div>
                <div className={!this.props.practice ? "appSection bgGrey" : "appSection bgYellow"}>
                    <div className={"container"}>
                        {
                            !this.props.practice ?
                            <InstructionModals
                                WSS
                                modalOpen={this.state.modalInstruction}
                                instructionMask={videoInstructionPN}
                                toggleInstruction={this.handleToggleInstruction}
                                closeClick={(active)=>{this.setState({modalInstruction: active});}}
                            />
                                : null
                        }
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={this.handleCloseModal} />
                        <div className="row">
                            <div className="appContainer wordsignsay">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        {countDown}
                                        {wordsSlideshow}
                                        <ul hidden={this.state.isUploading || this.state.recordedSession} className="list_items">
                                            {imageNumerical}
                                        </ul>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6" style={this.state.showVideo?{}:{display: 'none'}}>
                                        <div hidden={this.state.audioVideoSwitch==="video"} style={{paddingTop:"35%"}}>
                                            <audio ref={audio => { this.audio = audio }}/>
                                            <audio controls ref={audio2 => { this.audio2 = audio2 }}/>
                                        </div>
                                        <div hidden={this.state.isUploading || this.state.recording || this.state.recordedSession} style={{position:'absolute',margin:'auto',zIndex:1,top:65, left:0, bottom:0, right:0}}>
                                            <img src={videoMaskPN} style={{minWidth:200,width:'65%'}} />
                                        </div>
                                        <video id={"WordSignSayVidPlay"} hidden={this.state.audioVideoSwitch==="audio" || this.state.recordedSession} playsInline={true} ref={video => {
                                            this.video = video
                                        }}
                                               style={{position:'relative',top:65}}
                                               width="100%"
                                               autoPlay={true}
                                               controls={!this.state.recording && this.state.videoSrc && this.state.videoSrc !== ""}
                                               className={this.state.recording || !this.state.videoSrc || this.state.videoSrc === "" ? "flippedVideo":""}
                                               muted={this.state.recording || !this.state.videoSrc || this.state.recordedSession ? "muted": ""}
                                        />
                                    </div>
                                    <div style={{marginLeft: 720, marginTop: 450}}>
                                        <div style={{float: "left", width: 30}}>
                                            <input type="checkbox" defaultChecked={true} onChange={this.handleShowVideo} id="checkHideDeleted" className="form-control" />
                                        </div>
                                        <div style={{float: "left", marginTop: 9, marginLeft: 10}}>
                                            Show my video
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="divBottomRelative tr">
                                {/*<a onClick={this.handleBackToMenu}className="backArrow fl"><span>Back to Home Page</span></a>*/}
                                { !this.state.recording && !this.state.isUploading &&!this.state.isCounting ?
                                    <div className={"center-block text-center"} ><a  className={this.state.recordedSession ? "hidden" : "handBtn"} onClick={this.handleStartWordSignSay}><span>Start</span></a></div>
                                    : null}
                                {/*{this.state.recording===false ?*/}
                                    {/*<a className="handBtn navbar-right" onClick={this.toggleAudioVideo}>*/}
                                        {/*<span>Switch to {this.state.audioVideoSwitch==="video"?"Audio":"Video"}</span>*/}
                                    {/*</a> : null}*/}
                            </div>
                        </div>
                    </div>
                </div>
                <LoadingModal timer upTime={this.state.upTime} isUploading={this.state.isUploading}/>
            </div>
        )

    }
}

class Tutorial extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <WordSignSay studentUser={this.props.studentUser} buttonClick = {this.props.buttonClick} practice={true}/>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});
export default connect(mapStateToProps,bindActionToProps)(withRouter(WordSignSayComponent));



// WEBPACK FOOTER //
// ./src/StudentsComponent/WordSignSay.js